import { Trans, useTranslation } from 'react-i18next';
import ModalDialog from '../../../common/modal-dialog/modal-dialog.component';
import { HeaderSecondary } from '../../../common/typography/typography.styles';
import { ModalTextBody } from '../../../common/modal-dialog/modal-dialog.styles';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../stores/store';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onApprove: () => void;
}

const ModalLeaveParcelCreation = ({
  isOpen = false,
  onApprove,
  onClose,
}: Props) => {
  const { t } = useTranslation();

  const {
    commonStore: { isGuestParcelCreation },
  } = useStore();

  return (
    <ModalDialog
      isDanger={false}
      approveBtnContent={
        isGuestParcelCreation ? t('sign_in') : t('quit_remain')
      }
      cancelBtnContent={t('quit_leave')}
      isOpen={isOpen}
      useApproveLogicForDialogClosing
      onApprove={onApprove}
      onClose={onClose}>
      <HeaderSecondary>{t('quit_title')}</HeaderSecondary>
      <ModalTextBody>
        <Trans
          i18nKey='quit_text'
          components={{ br: <br /> }}
        />
      </ModalTextBody>
    </ModalDialog>
  );
};

export default observer(ModalLeaveParcelCreation);
